var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'base__btn',
    _vm.size,
    _vm.type == 'light' && _vm.clickable ? 'base__btn--clickable-1' : 'disabled',
    _vm.type == 'borderLight' ? 'base__btn--clickable-4' : '',
    _vm.type == 'normal' && _vm.clickable ? 'base__btn--clickable-2' : 'disabled',
    _vm.type == 'normalLight' && _vm.clickable
      ? 'base__btn--clickable-3'
      : 'disabled',
  ],on:{"click":_vm.clickHandle}},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }